/**********************************************************************
 ** Finance Routes                                                   **
 **********************************************************************/

(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // Finance menu
      $stateProvider.state('finance', {
        url: '/finance',
        abstract: true,
        views: {
          'mainmd': {
            template: `<div ui-view="financemain"></div>`
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('finance state entered, params: ', $state.params);
        }]
      });

      $stateProvider
        .state('finance.invoices', {
          url: '/invoices',
          views: {
            financemain: {template: '<invoicebrowser></invoicebrowser>'}
          }
        });

      $stateProvider
        .state('finance.invoices.cashinv', {
          url: '/cashinv',
          views: {
            invoicedetails: {template: '<cashinvoice mode=""></cashinvoice>'}
          },
          onEnter: function () {
            console.log('finance.invoices.cashinv entered');
          }
        });

      $stateProvider
        .state('finance.invoices.checkinv', {
          url: '/checkinv',
          views: {
            invoicedetails: {template: '<checkinvoice mode=""></checkinvoice>'}
          }
        });

      $stateProvider
        .state('finance.invoices.checkpaid', {
          url: '/checkpaid',
          views: {
            invoicedetails: {template: '<checkinvoice mode="paid"></checkinvoice>'}
          }
        });

      $stateProvider
        .state('finance.invoices.checkopen', {
          url: '/checkopen',
          views: {
            invoicedetails: {template: '<checkinvoice mode="open"></checkinvoice>'}
          }
        });

      $stateProvider
        .state('finance.invoices.checkoverdue', {
          url: '/checkoverdue',
          views: {
            invoicedetails: {template: '<checkinvoice mode="overdue"></checkinvoice>'}
          }
        });

      $stateProvider
        .state('finance.cashbook', {
          url: '/cashbook',
          views: {
            financemain: {component: 'cashbook'}
          },
          onEnter: ['$state', function onEnter($state) {
            console.log('finance.cashbook state entered, params: ', $state.params);
          }]
        });

      $stateProvider
        .state('finance.bmfexport', {
          url: '/bmfexport',
          views: {
            financemain: {component: 'bmfexport'}
          },
          onEnter: ['$state', function onEnter($state) {
            console.log('finance.bmfexport state entered, params: ', $state.params);
          }]
        });

      $stateProvider
        .state('finance.turnover', {
          url: '/turnover',
          views: {
            financemain: {template: '<turnover></turnover>'}
          }
        });

      $stateProvider
        .state('finance.rksv', {
          url: '/rksv',
          views: {
            financemain: {template: '<rksv-init></rksv-init><rksv-zero></rksv-zero><depexport></depexport><deplist></deplist>'}
          },
          onEnter: function () {
            console.log('finance.rksv state entered');
          }
        });


    }
// klammerfriedhof
  }
}());